// extracted by mini-css-extract-plugin
module.exports = {"show":"show-more_show__PD41J","more":"show-more_more__LoglR","button":"show-more_button__NxYl8"};